<template>
  <div>
    <Card shadow>
      <Row :gutter="16">
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">风控标签:</span>
            <Select
              clearable
              v-model="table.params.tag"
              placeholder="风控标签"
              filterable
              @on-change="() => SearList()"
            >
              <Option
                v-for="item in select.risk_tags_list"
                :value="item.value"
                :key="item.value"
                >{{ item.name }}</Option
              >
            </Select>
          </label>
        </Col>
        <Col span="4">
          <Button type="primary" @click="GetList()" icon="md-refresh"
            >刷新</Button
          >
        </Col>
        <Col span="8" offset="8">
          <Button type="info" @click="Refres" style="float: right"
            >同步配置</Button
          >
          <Button
            type="primary"
            @click="OpenModal1('add')"
            style="float: right; margin-right: 10px"
            >添加配置</Button
          >
        </Col>
      </Row>
    </Card>
    <Table
      class="mytable"
      border
      style="margin-top: 12px"
      :max-height="tableMaxHeight"
      :ref="table.ref"
      :columns="table.columns"
      :data="table.data"
      :loading="table.loading"
    />
    <Page
      show-total
      show-sizer
      style="margin-top: 12px"
      :page-size-opts="[20, 40, 60, 80]"
      :page-size="table.params.page_size"
      :total="table.page_total"
      :current="table.page_current"
      @on-change="ChangePage"
      @on-page-size-change="ChangePageSize"
    />

    <!-- 新增和编辑 -->
    <Modal
      v-model="modal1.show"
      @on-cancel="CloseModal1"
      :width="isMOble() ? '600px' : '980px'"
      class-name="vertical-center-modal"
    >
      <div slot="header">{{ modal1.title }}</div>
      <Form
        :ref="modal1.form.ref"
        :model="modal1.form.data"
        :rules="modal1.form.rules"
        :label-width="140"
        style="max-height: 750px; overflow-y: scroll; overflow-x: hidden"
      >
        <Card dis-hover>
          <Row>
            <FormItem label="风控名称" class="mylabel" prop="risk_name">
              <Col span="10">
                <Input
                  type="text"
                  v-model="modal1.form.data.risk_name"
                  :disabled="modal1.form.data.not_edit"
                />
              </Col>
            </FormItem>
          </Row>
          <Row>
            <FormItem label="风控标签" class="mylabel" prop="tag">
              <Col span="10">
                <Select
                  v-model="modal1.form.data.tag"
                  placeholder="风控标签"
                  :disabled="modal1.form.data.not_edit"
                >
                  <Option
                    v-for="item in select.risk_tags_list"
                    :value="item.value"
                    :key="item.value"
                    >{{ item.name }}</Option
                  >
                </Select>
              </Col>
            </FormItem>
          </Row>
          <Row>
            <FormItem label="设置风控方式">
              <Col span="22">
                <RadioGroup v-model="modal1.form.data.risk_mode">
                  <Radio :label="0" :disabled="modal1.form.data.not_edit"
                    >库存盈亏</Radio
                  >
                  <Radio :label="1" :disabled="modal1.form.data.not_edit"
                    >营收比</Radio
                  >
                </RadioGroup>
              </Col>
            </FormItem>
          </Row>
          <Row>
            <FormItem label="风控状态" prop="status">
              <Col span="10">
                <RadioGroup v-model="modal1.form.data.status">
                  <Radio label="1" :disabled="modal1.form.data.not_edit"
                    >开启</Radio
                  >
                  <Radio label="0" :disabled="modal1.form.data.not_edit"
                    >关闭</Radio
                  >
                </RadioGroup>
              </Col>
            </FormItem>
          </Row>
          <Row>
            <FormItem label="风控杀概率" prop="risk_rate">
              <Col span="10">
                <InputNumber
                  type="text"
                  v-model="modal1.form.data.risk_rate"
                  style="width: 100%"
                  :disabled="modal1.form.data.not_edit"
                  :min="0"
                /> </Col
              >&#8194;%
              <span style="color: red">最终风控执行杀概率</span>
            </FormItem>
          </Row>
          <Row>
            <FormItem label="风控送概率" prop="risk_rate_give">
              <Col span="10">
                <InputNumber
                  type="text"
                  v-model="modal1.form.data.risk_rate_give"
                  style="width: 100%"
                  :disabled="modal1.form.data.not_edit"
                  :min="0"
                /> </Col
              >&#8194;%
              <span style="color: red">最终风控执行送概率</span>
            </FormItem>
          </Row>
          <Row>
            <FormItem label="设置风控类型" prop="sys_type">
              <Col span="22">
                <RadioGroup v-model="modal1.form.data.sys_type">
                  <Radio label="1" :disabled="modal1.form.data.not_edit"
                    >持续开启杀风控</Radio
                  >
                  <Radio label="2" :disabled="modal1.form.data.not_edit"
                    >持续开启送风控</Radio
                  >
                  <Radio label="0" :disabled="modal1.form.data.not_edit"
                    >系统自动风控</Radio
                  >
                  <Radio label="3" :disabled="modal1.form.data.not_edit"
                    >关闭风控，累加库存</Radio
                  >
                </RadioGroup>
              </Col>
            </FormItem>
          </Row>
          <Row>
            <FormItem label="配置游戏名单">
              <Col span="22">
                <Button type="primary" @click="OpenModal2(modal1.form.data)"
                  >配置游戏名单</Button
                >
                <span style="color: #bbb">
                  （风控：{{
                    modal2.tree.sels.filter(v => /^stock/.test(v)).length
                  }}， 杀库：{{
                    modal2.tree.sels.filter(v => /^kill/.test(v)).length
                  }}， 送库：{{
                    modal2.tree.sels.filter(v => /^give/.test(v)).length
                  }}）
                </span>
              </Col>
              <Col span="9">
                <Checkbox v-model="modal1.form.data.is_self"
                  >对大平台生效</Checkbox
                >
              </Col>
            </FormItem>
          </Row>
        </Card>

        <Tabs type="card" value="name1" style="margin-top: 20px">
          <TabPane label="基础配置" name="name1" style="width: 100%">
            <Card dis-hover class="diy_card">
              <!-- <Row>
                                <FormItem label="生效时间">
                                    <Col span="8" v-for="(item, index) in modal1.form.data.times" :key="index">
                                        <Row class="modal1_item_box">
                                            <Col span="18">
                                                <TimePicker v-model="modal1.form.data.times[index]" format="HH:mm" type="timerange" placement="bottom-end" placeholder="请选择生效时间" style="width: 100%" />
                                            </Col>
                                            <Col span="6" style="text-align:right;">
                                                <Icon type="md-close-circle" size="18" class="del_icon" @click="DelTimes(index)" />
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span="8">
                                        <Button type="primary" @click="NewTimes()">新增</Button>
                                    </Col>
                                </FormItem>
                            </Row> -->
              <Row>
                <FormItem label="库存周期" prop="stock_period">
                  <Col span="10">
                    <Select
                      v-model="modal1.form.data.stock_period"
                      placeholder="库存周期"
                      :disabled="modal1.form.data.not_edit"
                    >
                      <Option
                        v-for="item in select.stock_period_list"
                        :value="item.value"
                        :key="item.value"
                        >{{ item.name }}</Option
                      >
                    </Select>
                  </Col>
                  <span style="color: red; margin-left: 10px; font-size: 12px"
                    >按周期时间清空库存</span
                  >
                </FormItem>
              </Row>
              <!-- <Row>
                                <FormItem label="库存累计起始时间" id="game-lib-time">
                                    <Col span="8">
                                        <TimePicker :transfer="false" v-model="modal1.form.data.stock_start_time" format="HH" type="time" placement="bottom-end" placeholder="库存累计起始时间" style="width: 100%" />
                                    </Col>
                                </FormItem>
                            </Row> -->
              <Row>
                <FormItem label="基础库存" prop="stock_base">
                  <Col span="10">
                    <InputNumber
                      type="text"
                      v-model="modal1.form.data.stock_base"
                      style="width: 100%"
                      :disabled="modal1.form.data.not_edit"
                    /> </Col
                  >&#8194;元
                  <span style="color: red; margin-left: 10px; font-size: 12px"
                    >根据游戏预估的投注填写</span
                  >
                </FormItem>
              </Row>
              <Row>
                <FormItem label="返奖库存" prop="stock_hit_base">
                  <Col span="10">
                    <InputNumber
                      type="text"
                      v-model="modal1.form.data.stock_hit_base"
                      style="width: 100%"
                      :disabled="modal1.form.data.not_edit"
                    />
                  </Col>
                  <Col span="1">&#8194;元</Col>
                  <Col span="4">
                    <Button type="primary" @click="Automatic()"
                      >自动计算</Button
                    >
                  </Col>
                  <span style="color: red; margin-left: 10px; font-size: 12px"
                    >返奖库存= 基础库存 * (1-风控下限)</span
                  >
                </FormItem>
              </Row>
              <Row>
                <FormItem label="风控下限" prop="profit_low">
                  <Col span="10">
                    <InputNumber
                      type="text"
                      v-model="modal1.form.data.profit_low"
                      style="width: 100%"
                      :disabled="modal1.form.data.not_edit"
                    /> </Col
                  >&#8194;%
                  <span style="color: red; margin-left: 10px; font-size: 12px"
                    >计算整体库存盈亏率下限，低于下限则杀</span
                  >
                </FormItem>
              </Row>
              <Row>
                <FormItem label="风控上限" prop="profit_upper">
                  <Col span="10">
                    <InputNumber
                      type="text"
                      v-model="modal1.form.data.profit_upper"
                      style="width: 100%"
                      :disabled="modal1.form.data.not_edit"
                    /> </Col
                  >&#8194;%
                  <span style="color: red; margin-left: 10px; font-size: 12px"
                    >计算整体库存盈亏率上限，高于上限则送</span
                  >
                </FormItem>
              </Row>

              <Row>
                <FormItem label="玩家杀阀值" prop="user_pros">
                  <Col span="10">
                    <InputNumber
                      type="text"
                      v-model="modal1.form.data.user_pros"
                      style="width: 100%"
                      :disabled="modal1.form.data.not_edit"
                    /> </Col
                  >&#8194;%
                  <span style="color: red; margin-left: 10px; font-size: 12px"
                    >杀的时候，再判断玩家的盈亏率【（投注-返奖）/投注】），小于盈亏率才杀</span
                  >
                </FormItem>
              </Row>
              <Row>
                <FormItem label="玩家送阀值" prop="user_give_pros">
                  <Col span="10">
                    <InputNumber
                      type="text"
                      v-model="modal1.form.data.user_give_pros"
                      style="width: 100%"
                      :disabled="modal1.form.data.not_edit"
                    /> </Col
                  >&#8194;%
                  <span style="color: red; margin-left: 10px; font-size: 12px"
                    >送的时候，再判断玩家的盈亏率【（投注-返奖）/投注】），大于盈亏率才送</span
                  >
                </FormItem>
              </Row>
              <Row>
                <FormItem label="单机游戏杀率" prop="single_kill">
                  <Col span="10">
                    <InputNumber
                      type="text"
                      v-model="modal1.form.data.single_kill"
                      style="width: 100%"
                      :disabled="modal1.form.data.not_edit"
                    /> </Col
                  >&#8194;%
                  <span style="color: red; margin-left: 10px; font-size: 12px"
                    >单机游戏判定杀的时候返奖率</span
                  >
                </FormItem>
              </Row>
              <Row>
                <FormItem label="单机游戏送率" prop="single_give">
                  <Col span="10">
                    <InputNumber
                      type="text"
                      v-model="modal1.form.data.single_give"
                      style="width: 100%"
                      :disabled="modal1.form.data.not_edit"
                    /> </Col
                  >&#8194;%
                  <span style="color: red; margin-left: 10px; font-size: 12px"
                    >单机游戏判定送的时候返奖率</span
                  >
                </FormItem>
              </Row>
              <Row>
                <FormItem label="最低人数限制" prop="min_exec_num">
                  <Col span="10">
                    <InputNumber
                      type="text"
                      v-model="modal1.form.data.min_exec_num"
                      style="width: 100%"
                      :disabled="modal1.form.data.not_edit"
                    /> </Col
                  >&#8194;
                  <span style="color: red; margin-left: 10px; font-size: 12px"
                    >PVE游戏小于人数限制不风控</span
                  >
                </FormItem>
              </Row>
            </Card>
          </TabPane>
        </Tabs>
      </Form>
      <div slot="footer">
        <Button
          type="primary"
          @click="CloseModal1"
          v-if="modal1.form.data.not_edit"
          >关闭</Button
        >
        <Button type="primary" @click="Update1" v-else>提交</Button>
      </div>
    </Modal>

    <!-- 配置游戏名单 -->
    <Modal
      :value="modal2.show"
      @on-cancel="CloseModal2"
      :width="isMOble() ? '600' : '800'"
      class-name="vertical-center-modal"
    >
      <div slot="header">配置游戏名单</div>

      <Tree
        :data="modal2.tree.data"
        :render="renderContent"
        class="game-lib-cof-table"
        style="max-height: 750px; overflow-y: scroll; overflow-x: hidden"
      />
      <div slot="footer">
        <Button
          type="primary"
          @click="CloseModal2"
          v-if="modal1.form.data.not_edit"
          >关闭</Button
        >
        <Button type="primary" @click="Save2" v-else>暂存</Button>
      </div>
    </Modal>

    <!-- 投注库存增减量 -->
    <Modal v-model="modal3.show" @on-cancel="CloseModal3" width="600">
      <div slot="header">投注库存增减量</div>
      <Form
        :ref="modal3.form.ref"
        :model="modal3.form.data"
        :rules="modal3.form.rules"
        :label-width="120"
        @submit.native.prevent
      >
        <Row>
          <Col span="20">
            <FormItem label="投注库存增减量">
              <InputNumber
                type="text"
                v-model="modal3.form.data.a_stock"
                style="width: 100%"
              />
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="20">
            <FormItem label
              >注: 确定之后,投注 = 当前投注库存 + 投注库存增减量</FormItem
            >
          </Col>
        </Row>
      </Form>

      <div slot="footer">
        <Button type="primary" @click="Update3">提交</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import {
  GetGameRiskList,
  UpdateGameRisk,
  GetAllGameList,
  GetAppTagList,
  GetGameRoomInfo,
  DelGameRisk,
  UpdateGameRiskStock,
  RefreshConfig
} from '@/api/admin/risk'
export default {
  name: 'gameLibConf',
  data() {
    return {
      select: {
        app_list: [],
        game_list: [],
        risk_tags_list: [],
        risk_type_list: [
          { value: 1, name: '百人类风控' },
          { value: 2, name: 'PVP类风控' },
          { value: 3, name: '捕鱼风控' },
          { value: 4, name: '红包' }
        ],
        stock_period_list: [
          // { value:1, name:'小时库存' },
          { value: 2, name: '天库存' },
          { value: 3, name: '周库存' },
          { value: 4, name: '月库存' }
        ]
      },
      tableMaxHeight: 0,
      table: {
        ref: 'table',
        loading: false,
        params: { game_id: '', tag: '', page: 1, page_size: 20 },
        columns: [
          { type: 'index', title: '序号', width: 50, align: 'center' },
          {
            title: '编号',
            key: 'id',
            sortable: true,
            width: 100,
            resizable: true,
            align: 'center'
          },
          {
            title: '风控名称',
            key: 'risk_name',
            width: 160,
            resizable: true,
            align: 'center'
          },
          {
            title: '风控标签',
            key: 'tag',
            width: 160,
            resizable: true,
            sortable: true,
            align: 'center',
            render: (h, params) => {
              let tag_info = this.select.risk_tags_list.find(
                v => v.value == params.row.tag
              )
              return h('div', tag_info ? tag_info.name : '')
            },
            // filters: [],
            // filterMultiple: true,
            // filterMethod: (value, row) => {
            //   return row.tag == value
            // }
          },
          {
            title: '风控方式',
            key: 'risk_mode',
            width: 160,
            resizable: true,
            align: 'center',
            render: (h, params) => {
              return h(
                'div',
                {
                  style: {
                    color: `${['#2db7f5', '#ff9900'][params.row.risk_mode]}`
                  }
                },
                ['库存盈亏', '营收比'][params.row.risk_mode]
              )
            }
          },
          {
            title: '基础库存',
            key: 'stock_base',
            width: 160,
            resizable: true,
            sortable: true,
            align: 'center',
            render: (h, params) => h('div', params.row.stock_base),
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '基础库存',
                '预防初始生成数据时盈亏税收比出现较大的波动影响大盘的风控'
              )
          },

          {
            title: '风控率下 / 上限 / 杀阀值 / 送阀值',
            width: 160,
            resizable: true,
            align: 'center',
            render: (h, params) =>
              h(
                'span',
                `${params.row.profit_low / 100}% / ${params.row.profit_upper /
                  100}% / ${params.row.user_pros / 100}%/ ${params.row
                  .user_give_pros / 100}%`
              ),
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '风控率下 / 上限 / 阀值',
                '低于风控下限开启杀，高于风控上限开启送，阀值用于计算库存同时控制子游戏是否风控生效'
              )
          },
          {
            title: '风控状态',
            key: 'sys_type',
            width: 160,
            resizable: true,
            align: 'center',
            render: (h, params) => {
              let arr = [
                h(
                  'span',
                  {
                    style: {
                      color: params.row.status ? '#19be6b' : '#ed4014'
                    }
                  },
                  params.row.status ? '开启' : '关闭'
                )
              ]
              arr.push(h('span', ' / '))
              if (params.row.status == 0) {
                arr.push(h('span', '--'))
              } else {
                arr.push(
                  h(
                    'span',
                    {
                      style: {
                        color: ['#333', 'red', '#32CD32', ''][
                          params.row.sys_type
                        ]
                      }
                    },
                    ['自动', '杀', '送', '关闭'][params.row.sys_type]
                  )
                )
              }

              return h('div', arr)
            }
          },
          {
            title: '风控杀概率',
            key: 'risk_rate',
            width: 160,
            resizable: true,
            align: 'center',
            render: (h, params) => h('div', params.row.risk_rate + '%')
          },
          {
            title: '风控送概率',
            key: 'risk_rate_give',
            width: 160,
            resizable: true,
            align: 'center',
            render: (h, params) => h('div', params.row.risk_rate_give + '%')
          },
          {
            title: '更新时间',
            key: 'update_time',
            width: 160,
            resizable: true,
            sortable: true,
            align: 'center'
          },
          {
            fixed: this.isMOble() ? '' : 'right',
            title: '详情信息管理',
            align: 'center',
            minWidth: 160,
            render: (h, params) => {
              let btn1_str = params.row.not_edit ? '查看设置' : '风控设置'
              return h('div', [
                h(
                  'Button',
                  {
                    props: { type: 'primary' },
                    style: { marginRight: '5px' },
                    on: {
                      click: () => {
                        this.OpenModal1('edit', params.row)
                      }
                    }
                  },
                  btn1_str
                ),
                h(
                  'Button',
                  {
                    props: {
                      type: 'error',
                      disabled: params.row.not_edit
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: '确认删除',
                          onOk: () => {
                            this.Delete(params.row)
                          }
                        })
                      }
                    }
                  },
                  '删除'
                )
              ])
            }
          }
        ],
        data: [],
        page_total: 1,
        page_current: 1
      },
      modal1: {
        title: '',
        select: { room_list: [] },
        show: false,
        type: 'add',
        form: {
          ref: 'modal1_form',
          data: { stock_start_time: '00' },
          rules: {}
        }
      },
      modal2: {
        show: false,
        tree: {
          data: [],
          sels_old: [],
          sels: [],
          btn_all: [
            {
              stock: {
                value: '',
                data: [],
                check: false,
                indeterminate: false
              },
              kill: { value: '', data: [], check: false, indeterminate: false },
              give: { value: '', data: [], check: false, indeterminate: false }
            }
          ]
        }
      },
      modal3: {
        show: false,
        form: {
          ref: 'modal2_form',
          data: { id: 0, stock: null }
        }
      }
    }
  },
  methods: {
    Automatic() {
      this.modal1.form.data['stock_hit_base'] =
        parseInt(this.modal1.form.data['stock_base'] * (1 - this.modal1.form.data['profit_low'] / 100))
    },
    Refres() {
      let param = {
        is_all: 1,
        refresh_cfg: [2]
      }
      RefreshConfig(param).then(res => {
        this.$Notice.success({
          title: '操作提示',
          desc: '成功刷新配置'
        })
        this.GetList()
      })
    },
    GetGameList() {
      return new Promise((resolve, reject) => {
        let param = { gtype: 0, page: 1, page_size: 10000 }
        GetAllGameList(param).then(res => {
          let data = res._param.data
          let nlist = []
          data.map(item => {
            nlist.push({
              value: item.game_id,
              name: item.game_name
            })
          })
          this.select.game_list = nlist

          resolve(true)
        })
      })
    },
    GetAppTagListList() {
      return new Promise((resolve, reject) => {
        let param = {
          sale_type: -1,
          tag_type: 'risk_tag',
          page: 1,
          page_size: 10000
        }
        GetAppTagList(param).then(res => {
          let data = res._param.List || []
          let nlist = []
          let nfilters = []

          data.map(item => {
            nlist.push({
              value: item.id,
              name: item.tag_name
            })
            nfilters.push({
              value: item.id,
              label: item.tag_name
            })
          })
          this.select.risk_tags_list = nlist
          this.table.columns[3].filters = nfilters
          resolve(true)
        })
      })
    },
    GetList(_params) {
      let params = { ...this.table.params }
      params.game_id = Number(params.game_id)
      params.tag = Number(params.tag)

      if (_params) {
        params = { ..._params }
      }

      GetGameRiskList(params).then(res => {
        let data = res._param
        // 兼容表格排序
        let ndata = data.data || []
        ndata = ndata.map(item => {
          let data = this.copyData(item)
          // 游戏盈亏 字段
          data.key7 = Math.round((data.bet_stock - data.hit_stock) / 100) / 100
          return data
        })
        this.table.data = ndata
        this.table.page_total = data.total
      })
    },
    ChangePage(page) {
      this.table.params.page = page
      this.table.page_current = page
      this.table['sel_ids'] = []
      this.GetList()
    },
    ChangePageSize(page_size) {
      this.table.params.page = 1
      this.table.page_current = 1
      this.table.params.page_size = page_size
      this.table['sel_ids'] = []
      this.GetList()
    },
    SearList(params) {
      this.table.params.page = 1
      this.$refs[this.table.ref]['currentPage'] = 1
      this.table.page_current = 1
      this.GetList(params)
    },
    Delete(data) {
      let params = { id: data.id }
      DelGameRisk(params).then(res => {
        this.GetAppTagListList().then(() => {
          this.$Notice.success({
            title: '操作提示',
            desc: '成功删除'
          })
          this.GetList()
        })
      })
    },
    OpenModal1(type, row = {}) {
      this.modal1.show = true
      this.modal1.type = type

      let title = '新增风控库'
      if (type == 'edit') {
        if (!row.not_edit) {
          title = '编辑风控库'
        } else {
          title = '查看风控库'
        }
      }
      this.modal1.title = title

      // 风控库信息
      let data = {
        status: 0,
        sys_type: 0,
        risk_mode: 0,
        stock_period: 2,
        risk_rate: 0,
        risk_rate_give: 0,
        stock_base: 0,
        profit_low: 0,
        profit_upper: 0,
        game_pros: 0,
        pvp_pros: 0,
        user_pros: 0,
        user_give_pros: 0,
        single_kill: 0,
        single_give: 0,
        is_open_num: 1,
        open_time: 0,
        num_count: 0,
        loss_point_rate: 0,
        loss_num_rate: 0,
        min_exec_num: 0,
        exec_rate: 0,
        is_self: false,
        stock_attach_gids: [],
        kill_attach_gids: [],
        give_attach_gids: [],
        num_attach_gids: [],
        times: [],
        stock_hit_base: 0,
        ...row
      }
      data.stock_start_time = data.stock_start_time
        ? data.stock_start_time > 10
          ? `${data.stock_start_time}`
          : `0${data.stock_start_time}`
        : '00'
      data.status = data.status.toString()
      data.sys_type = data.sys_type.toString()
      data.profit_low = data.profit_low / 100
      data.profit_upper = data.profit_upper / 100
      data.game_pros = data.game_pros / 100
      data.pvp_pros = data.pvp_pros / 100
      data.user_pros = data.user_pros / 100
      data.user_give_pros = data.user_give_pros / 100
      data.single_kill = data.single_kill / 100
      data.single_give = data.single_give / 100
      data.loss_point_rate = data.loss_point_rate / 100
      data.loss_num_rate = data.loss_num_rate / 100
      // data.stock_base = data.stock_base / 10000
      data.is_self = !!data.is_self
      if (data.times == null || data.times.length == 0) {
        data.times = []
        data.times.push(['00:00', '23:59'])
      } else {
        data.times = data.times.map(item => {
          return [item.m, item.n]
        })
      }

      this.modal1.form.data = data

      // 配置游戏名单信息
      let sels = []
      data.stock_attach_gids.map(item => {
        sels.push('stock.' + item)
      })
      data.kill_attach_gids.map(item => {
        sels.push('kill.' + item)
      })
      data.give_attach_gids.map(item => {
        sels.push('give.' + item)
      })
      data.stock_attach_gids.map(item => {
        sels.push('stock.' + item)
      })
      data.num_attach_gids.map(item => {
        sels.push('num.' + item)
      })
      let arr_old = Array.from(new Set(sels))
      this.modal2.tree.sels_old = arr_old
      let arr_sels = Array.from(new Set(sels))
      this.modal2.tree.sels = arr_sels
    },
    CloseModal1() {
      this.$refs[this.modal1.form.ref].resetFields()
      this.modal1.show = false
    },
    ChangeInfoAppRisk() {
      this.modal2.tree.sels = []
    },
    NewTimes() {
      this.modal1.form.data['times'].push(['', ''])
    },
    DelTimes(index) {
      this.modal1.form.data['times'].splice(index, 1)
    },
    Update1() {
      let params = { id: 0, ...this.modal1.form.data }
      params.status = Number(params.status)
      params.sys_type = Number(params.sys_type)
      params.stock_attach_gids = []
      params.kill_attach_gids = []
      params.give_attach_gids = []
      params.num_attach_gids = []
      this.modal2.tree.sels.map(item => {
        if (/^stock/.test(item)) {
          params.stock_attach_gids.push(item.replace(/stock./, ''))
          params.stock_attach_gids = Array.from(
            new Set(params.stock_attach_gids)
          )
        }
        if (/^kill/.test(item)) {
          params.kill_attach_gids.push(item.replace(/kill./, ''))
          params.kill_attach_gids = Array.from(new Set(params.kill_attach_gids))
        }
        if (/^give/.test(item)) {
          params.give_attach_gids.push(item.replace(/give./, ''))
          params.give_attach_gids = Array.from(new Set(params.give_attach_gids))
        }
        if (/^num/.test(item)) {
          params.num_attach_gids.push(item.replace(/num./, ''))
          params.num_attach_gids = Array.from(new Set(params.num_attach_gids))
        }
      })

      // params.stock_base = params.stock_base * 10000
      params.profit_low = Math.round(params.profit_low * 100)
      params.profit_upper = Math.round(params.profit_upper * 100)
      params.game_pros = Math.round(params.game_pros * 100)
      params.pvp_pros = Math.round(params.pvp_pros * 100)
      params.user_pros = Math.round(params.user_pros * 100)
      params.user_give_pros = Math.round(params.user_give_pros * 100)
      params.single_kill = Math.round(params.single_kill * 100)
      params.single_give = Math.round(params.single_give * 100)
      params.loss_point_rate = Math.round(params.loss_point_rate * 100)
      params.loss_num_rate = Math.round(params.loss_num_rate * 100)
      params.is_self = params.is_self ? 1 : 0
      params.stock_start_time = parseInt(params.stock_start_time)
      params.times = params.times
        .map(item => {
          return {
            m: item[0],
            n: item[1]
          }
        })
        .filter(v => v.m && v.n)
      UpdateGameRisk(params).then(res => {
        this.GetAppTagListList().then(() => {
          this.CloseModal1()
          this.GetList()
        })
      })
    },
    renderContent(h, { root, node, data }) {
      let id_rule_level = `${data.game_id}.${data.rule}.${data.level}`
      let stock_id_rule_level = `stock.${id_rule_level}`
      let kill_id_rule_level = `kill.${id_rule_level}`
      let give_id_rule_level = `give.${id_rule_level}`
      let num_id_rule_level = `num.${id_rule_level}`
      let disabled = this.modal1.form.data['not_edit']

      let arr2 = [h('span', data.Gname)]
      if (!data.children) {
        arr2.push(
          h('span', { style: { color: '#bbb' } }, `（${id_rule_level}）`)
        )
      }

      let arr1 = [
        h('span', [
          h('Icon', {
            props: { type: 'ios-paper-outline' },
            style: { marginRight: '8px' }
          }),
          h('span', arr2)
        ])
      ]

      if (!data.children) {
        arr1.push(
          h(
            'span',
            {
              style: {
                display: 'inline-block',
                float: 'right',
                marginRight: '32px'
              }
            },
            [
              h(
                'CheckboxGroup',
                {
                  props: { value: this.modal2.tree.sels },
                  on: {
                    input: data => {
                      let data_old = this.modal2.tree.sels_old
                      let data_new = data
                      if (data_old.length > data_new.length) {
                        let item = data_old.filter(
                          v => !data_new.includes(v)
                        )[0]

                        let type = item.split('.')[0]
                        let id_rule_level =
                          item.split('.')[1] +
                          '.' +
                          item.split('.')[2] +
                          '.' +
                          item.split('.')[3]
                        if (type == 'stock') {
                          if (data_new.includes('kill.' + id_rule_level)) {
                            data_new.splice(
                              data_new.findIndex(
                                item => item === 'kill.' + id_rule_level
                              ),
                              1
                            )
                            // data_new.remove("kill." + id_rule_level);
                          }
                          if (data_new.includes('give.' + id_rule_level)) {
                            data_new.splice(
                              data_new.findIndex(
                                item => item === 'give.' + id_rule_level
                              ),
                              1
                            )
                            // data_new.remove("give." + id_rule_level);
                          }
                        }
                      } else {
                        let item = data_new.filter(
                          v => !data_old.includes(v)
                        )[0]
                        let type = item.split('.')[0]
                        let id_rule_level =
                          item.split('.')[1] +
                          '.' +
                          item.split('.')[2] +
                          '.' +
                          item.split('.')[3]
                        if (type != 'stock') {
                          let nitem = 'stock.' + id_rule_level
                          data_new.indexOf(nitem) < 0 && data_new.push(nitem)
                        }
                      }

                      this.modal2.tree.sels_old = data
                      this.modal2.tree.sels = data
                    }
                  }
                },
                [
                  h(
                    'Checkbox',
                    {
                      props: {
                        label: stock_id_rule_level,
                        disabled: disabled
                      },
                      style: { marginRight: '8px' }
                    },
                    '风控库'
                  ),
                  h(
                    'Checkbox',
                    {
                      props: {
                        label: kill_id_rule_level,
                        disabled: disabled
                      },
                      style: { marginRight: '8px' }
                    },
                    '杀库'
                  ),
                  h(
                    'Checkbox',
                    {
                      props: {
                        label: give_id_rule_level,
                        disabled: disabled
                      }
                    },
                    '送库'
                  ),
                  h(
                    'Checkbox',
                    {
                      props: {
                        label: num_id_rule_level,
                        disabled: disabled
                      }
                    },
                    '人数控制'
                  )
                ]
              )
            ]
          )
        )
      } else {
        arr1.push(
          h(
            'span',
            {
              style: {
                display: 'inline-block',
                float: 'right',
                marginRight: '32px'
              }
            },
            [
              h(
                'Checkbox',
                {
                  props: {
                    value: this.modal2.tree.btn_all[data.index].stock.value,
                    disabled: disabled
                  },
                  style: { marginRight: '8px' },
                  on: {
                    input: checked => {
                      let reg = new RegExp(`${data.game_id}`)
                      let item = this.modal2.tree.btn_all[data.index]
                      item.stock.value = checked
                      if (checked) {
                        item.stock.all_data.map(item1 => {
                          this.modal2.tree.sels.push(item1)
                        })
                        let nsels = Array.from(new Set(this.modal2.tree.sels))
                        this.modal2.tree.sels_old = nsels
                        this.modal2.tree.sels = nsels
                      } else {
                        item.kill.value = false
                        item.give.value = false
                        item['num'].value = false
                        let nsels = this.modal2.tree.sels.filter(
                          v => !reg.test(v)
                        )
                        this.modal2.tree.sels_old = nsels
                        this.modal2.tree.sels = nsels
                      }
                    }
                  }
                },
                '全选　'
              ),
              h(
                'Checkbox',
                {
                  props: {
                    value: this.modal2.tree.btn_all[data.index].kill.value,
                    disabled: disabled
                  },
                  style: { marginRight: '8px' },
                  on: {
                    input: checked => {
                      let item = this.modal2.tree.btn_all[data.index]
                      item.kill.value = checked

                      if (checked) {
                        item.stock.value = true
                        item.stock.all_data.map(item1 => {
                          this.modal2.tree.sels.push(item1)
                        })
                        item.kill.all_data.map(item1 => {
                          this.modal2.tree.sels.push(item1)
                        })
                        this.modal2.tree.sels = Array.from(
                          new Set(this.modal2.tree.sels)
                        )
                      } else {
                        this.modal2.tree.sels = this.modal2.tree.sels.filter(
                          item1 => !item.kill.all_data.includes(item1)
                        )
                        // item.kill.all_data.map((item) => {
                        //     (this.modal2.tree.sels).remove(item);
                        // });
                      }
                      this.modal2.tree.sels_old = this.modal2.tree.sels
                    }
                  }
                },
                '全选'
              ),
              h(
                'Checkbox',
                {
                  props: {
                    value: this.modal2.tree.btn_all[data.index].give.value,
                    disabled: disabled
                  },
                  on: {
                    input: checked => {
                      let item = this.modal2.tree.btn_all[data.index]
                      item.give.value = checked
                      if (checked) {
                        item.stock.value = true
                        item.stock.all_data.map(item1 => {
                          this.modal2.tree.sels.push(item1)
                        })
                        item.give.all_data.map(item1 => {
                          this.modal2.tree.sels.push(item1)
                        })
                        this.modal2.tree.sels = Array.from(
                          new Set(this.modal2.tree.sels)
                        )
                      } else {
                        this.modal2.tree.sels = this.modal2.tree.sels.filter(
                          item1 => !item.give.all_data.includes(item1)
                        )
                      }
                      this.modal2.tree.sels_old = this.modal2.tree.sels
                    }
                  }
                },
                '全选'
              ),
              h(
                'Checkbox',
                {
                  props: {
                    value: this.modal2.tree.btn_all[data.index]['num'].value,
                    disabled: disabled
                  },
                  on: {
                    input: checked => {
                      let item = this.modal2.tree.btn_all[data.index]['num']
                      item.value = checked

                      if (checked) {
                        item.all_data.map(item => {
                          this.modal2.tree.sels.push(item)
                        })
                        this.modal2.tree.sels = Array.from(
                          new Set(this.modal2.tree.sels)
                        )
                      } else {
                        this.modal2.tree.sels = this.modal2.tree.sels.filter(
                          item1 => !item.all_data.includes(item1)
                        )
                        // item.all_data.map((item) => {
                        //     (this.modal2.tree.sels).remove(item);
                        // });
                      }
                      this.modal2.tree.sels_old = this.modal2.tree.sels
                    }
                  }
                },
                '　全选　'
              )
            ]
          )
        )
      }

      let fn = h(
        'span',
        { style: { display: 'inline-block', width: '100%' } },
        arr1
      )

      return fn
    },
    GetGameRoomList() {
      let params = { gtype: 0 }

      // if(Number(params.gtype) === params.gtype){
      GetGameRoomInfo(params).then(res => {
        let data = res._param.data || []

        // 缓存全部数据
        let ndata = []
        data.map((item, index) => {
          let ndata_info = ndata.filter(v => v.game_id == item.game_id)[0]

          let all_stock_id = `all_stock_${item.game_id}`
          let all_kill_id = `all_kill_${item.game_id}`
          let all_give_id = `all_give_${item.game_id}`
          let stock_id_rule_level = `stock.${item.game_id}.${item.rule}.${item.level}`
          let kill_id_rule_level = `kill.${item.game_id}.${item.rule}.${item.level}`
          let give_id_rule_level = `give.${item.game_id}.${item.rule}.${item.level}`
          let num_id_rule_level = `num.${item.game_id}.${item.rule}.${item.level}`

          if (ndata_info) {
            ndata_info.stock.all_data.push(stock_id_rule_level)
            ndata_info.kill.all_data.push(kill_id_rule_level)
            ndata_info.give.all_data.push(give_id_rule_level)
            ndata_info.num.all_data.push(num_id_rule_level)
          } else {
            ndata.push({
              game_id: item.game_id,
              index: index,
              stock: {
                value: false,
                all_data: [stock_id_rule_level],
                check: false,
                indeterminate: false
              },
              kill: {
                value: false,
                all_data: [kill_id_rule_level],
                check: false,
                indeterminate: false
              },
              give: {
                value: false,
                all_data: [give_id_rule_level],
                check: false,
                indeterminate: false
              },
              num: {
                value: false,
                all_data: [num_id_rule_level],
                check: false,
                indeterminate: false
              }
            })
          }
        })
        this.modal2.tree.btn_all = ndata

        // 构建 数据树结构
        let tree_data = []
        let n = -1
        data.map(item => {
          let tree_data_info = tree_data.filter(
            v => v.game_id == item.game_id
          )[0]
          if (tree_data_info) {
            tree_data_info.children.push({
              expand: true,
              ...item
            })
          } else {
            tree_data.push({
              index: ++n,
              Gname: item.Gname,
              game_id: item.game_id,
              expand: true,
              children: [
                {
                  expand: true,
                  ...item
                }
              ]
            })
          }
        })
        this.modal2.tree.data = tree_data
      })
      // }
    },
    OpenModal2(data = {}) {
      this.modal2.show = true

      this.GetGameRoomList()
    },
    CloseModal2() {
      this.modal2.show = false
      this.modal2.tree.data = []
    },
    Save2() {
      let data = this.modal2.tree.sels
      let kill_attach_gids = []
      let give_attach_gids = []
      let num_attach_gids = []

      data.map(item => {
        if (/^kill/.test(item)) kill_attach_gids.push(item.replace('kill.', ''))
        if (/^give/.test(item)) give_attach_gids.push(item.replace('give.', ''))
        if (/^num/.test(item)) num_attach_gids.push(item.replace('num.', ''))
      })

      let stock_attach_gids = Array.from(
        new Set([...kill_attach_gids, ...give_attach_gids])
      )

      this.modal1.form.data['stock_attach_gids'] = stock_attach_gids
      this.modal1.form.data['kill_attach_gids'] = kill_attach_gids
      this.modal1.form.data['give_attach_gids'] = give_attach_gids
      this.modal1.form.data['num_attach_gids'] = num_attach_gids

      this.CloseModal2()

      // UpdateGameRiskStock(params).then(res =>{
      //     this.$Notice.success({
      //         title: '操作提示',
      //         desc: '修改库存成功'
      //     });
      //     this.CloseModal2()
      //     this.GetList()
      // })
    },
    OpenModal3(row) {
      this.modal3.show = true
      this.modal3.form.data['id'] = row.id
      this.modal3.form.data['a_stock'] = row.a_stock || 0
    },
    CloseModal3() {
      this.modal3.show = false
    },
    Update3() {
      let params = { ...this.modal3.form.data }
      params.stock = params['a_stock']
      delete params['a_stock']

      UpdateGameRiskStock(params).then(res => {
        this.$Notice.success({
          title: '操作提示',
          desc: '修改库存成功'
        })
        this.CloseModal3()
        this.GetList()
      })
    }
  },
  created() {
    if (this.$route.params.tag != undefined) {
      this.table.params.tag = this.$route.params.tag
    }
    if (this.$route.params.id) {
      this.table.params.tag = Number(this.$route.params.id)
    }
    this.GetGameList(), this.GetAppTagListList()
    this.GetList()
  },
  mounted() {
    this.tableMaxHeight = window.document.body.clientHeight - 270
  },
  watch: {
    $route() {
      if (this.$route.params.id) {
        this.table.params.tag = Number(this.$route.params.id)
      }
    }
  }
}
</script>

<style lang="less">
.game-lib-cof-table {
  .ivu-tree-title {
    width: 100% !important;
  }
}
.mylabel label {
  position: absolute;
}
.modal3_btn_list {
  text-align: center;
  button {
    margin: 0 5px;
  }
}
.ivu-form-item-error-tip {
  top: 33px;
}
.ivu-tabs-card {
  .ivu-tabs-bar {
    margin-bottom: 0 !important;
  }
}
.diy_card {
  border-top: 0px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-color: #dcdee2;
  padding-top: 20px;
}
.ivu-tree > .ivu-tree-children {
  border-top: solid 1px #e8eaec;
  &:first-child {
    border-top: 0;
  }
}
.mytable {
  .ivu-table-cell {
    padding-left: 2px !important;
    padding-right: 2px !important;
  }
}

.modal1_item_box {
  position: relative;
  margin-bottom: 10px;
  .del_icon {
    position: absolute;
    left: 7px;
    top: 7px;
    z-index: 1;
    cursor: pointer;
    display: none;
  }
  &:hover {
    .del_icon {
      display: block;
    }
  }
}
.ivu-tree-title {
  width: 100%;
}
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}
</style>
